// FanFare shared types & enums.
// See /var/www/fanfare/CLAUDE_ENGINEERING_PRINCIPLES.md — Code Enums Over DB Enums.

export const APP_NAME = 'FanFare';

export enum FanTier {
  Free = 'free',
  Fan = 'fan',
  SuperFan = 'super_fan',
  MegaFan = 'mega_fan',
}

export enum BlueprintStatus {
  Draft = 'draft',
  Synthesizing = 'synthesizing',
  Published = 'published',
  Archived = 'archived',
}
